import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import MUIButton from "@mui/material/Button";
import MUICard from "@mui/material/Card";
import MUICardContent from "@mui/material/CardContent";
import MUICardHeader from "@mui/material/CardHeader";
import MUIContainer from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MUIGrid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import MUITextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ReactTooltip from "react-tooltip";
import ManualDocumentCreation from "./manualDocumentBuilderService";
import ManualDocumentBuilderModal from "./ManualDocumentBuilderModal";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class manualDocumentBuilder extends LayerLegacy {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      success: "",
      orderIdsInput: "",
      modal: false,
      processModal: false,
      processMode: "manual",
      documents: [],
      documentOptions: [],
      selectedDocumentOption: {},
      selectedProcessDocumentOptions: [],
      processOrderIds: [],
      shouldIncludeAorDocument: false,
      latestProcessPreview: [],
    };
  }

  static contextType = MainContext; // For legacy class components

  renderMessage() {
    const state = this.state;

    if (state.error.length > 0) {
      return (
        <Typography color="error" gutterBottom>
          {state.error}
        </Typography>
      );
    } else if (state.success.length > 0) {
      return (
        <Typography
          gutterBottom
          sx={{
            color: "success.main",
          }}
        >
          {state.success}
        </Typography>
      );
    } else {
      return <div></div>;
    }
  }

  clearMessage() {
    setTimeout(() => {
      this.setState({ error: "", success: "" });
    }, 5000);
  }

  createDeliveryPaperwork = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.representativeSignature){
    //	obj.representativeSignature = obj.representativeSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.technicianSignature){
    //	obj.technicianSignature = obj.technicianSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createEquipmentDeliveryDocument(
      documentPayload,
    )
      .then(() => {
        this.setState({
          error: "",
          success: "Success",
        });
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createSafetyAssessment = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.representativeSignature){
    //	obj.representativeSignature = obj.representativeSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createSafetyAssessment(documentPayload)
      .then(() => {
        this.setState({
          error: "",
          success: "Success",
        });
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createHomeAssessment = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.representativeSignature){
    //	obj.representativeSignature = obj.representativeSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createHomeAssessment(documentPayload)
      .then((response) => {
        if (response.uploadHomeAssessmentForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createABN = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.signature){
    //	obj.signature = obj.signature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createABN(documentPayload)
      .then((response) => {
        if (response.uploadAbnForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createPickup = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.technicianSignature){
    //	obj.technicianSignature = obj.technicianSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createPickup(documentPayload)
      .then((response) => {
        if (response.uploadPickupForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createServiceTicket = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.technicianSignature){
    //	obj.technicianSignature = obj.technicianSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createServiceTicket(documentPayload)
      .then((response) => {
        if (response.uploadServiceForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createComplexPaperwork = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.signature){
    //	obj.signature = obj.signature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createComplexPaperwork(documentPayload)
      .then((response) => {
        if (response.uploadComplexForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createSalesAgreement = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientSignature){
    //	obj.patientSignature = obj.patientSignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.technicianSignature){
    //	obj.technicianSignature = obj.technicianSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createSalesAgreement(documentPayload)
      .then((response) => {
        if (response.uploadSalesAgreementForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createDonationForm = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.responsiblePartySignature){
    //	obj.responsiblePartySignature = obj.responsiblePartySignature.split("data:image/png;base64,")[1];
    //}
    //if(obj.technicianSignature){
    //	obj.technicianSignature = obj.technicianSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createDonationForm(documentPayload)
      .then((response) => {
        if (response.uploadDonationForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createEmailDocument = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientEmailSignature){
    //	obj.patientEmailSignature = obj.patientEmailSignature.split("data:image/png;base64,")[1];
    //}

    return ManualDocumentCreation.createEmailDocument(documentPayload)
      .then((response) => {
        if (response.uploadEmailForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  mergePaperwork = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    //if(obj.patientEmailSignature){
    //	obj.patientEmailSignature = obj.patientEmailSignature.split("data:image/png;base64,")[1];
    //}

    documentPayload.dontSendSurvey = true;

    return ManualDocumentCreation.mergePaperwork(documentPayload)
      .then((response) => {
        if (response.submitMerge) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  createAorAgreement = () => {
    const documentText = document.getElementById("docText").value;
    const documentPayload = JSON.parse(documentText);

    return ManualDocumentCreation.createAorDocument(documentPayload)
      .then((response) => {
        if (response.uploadSalesAgreementForm) {
          this.setState({
            error: "",
            success: "Success",
          });
        }
      })
      .catch((error) => {
        this.setState({
          error,
          success: "",
        });
      })
      .finally(() => {
        this.clearMessage();
      });
  };

  parseOrderIds = (orderIdsText = this.state.orderIdsInput) => {
    if (!orderIdsText) {
      return [];
    }

    return [
      ...new Set(
        orderIdsText
          .split(/[\s,;]+/)
          .map((orderId) => orderId.trim())
          .filter(Boolean),
      ),
    ];
  };

  loadPaperworkOptions = (orderId = this.state.orderIdsInput) => {
    return ManualDocumentCreation.getDeliveryDocs({
      orderId,
    })
      .then((documents) => {
        console.log(documents);
        const documentOptions = [];
        documents.map((documentRecord) => {
          return documentOptions.push({
            label:
              documentRecord.documentType +
              " - " +
              //new Date(documentRecord.uploadedOn).toLocaleString(),
              documentRecord.uploadedOn,
            value: documentRecord.id,
            docInfo: documentRecord.docInfo,
            documentType: documentRecord.documentType,
            uploadedOn: documentRecord.uploadedOn,
            orderId,
          });
        });
        return {
          documents,
          documentOptions,
        };
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  };

  getPaperWorkById = () => {
    const orderIds = this.parseOrderIds();
    const orderId = orderIds[0];

    if (!orderId) {
      this.setState({
        error: "Enter at least one order ID.",
        success: "",
      });
      this.clearMessage();
      return Promise.resolve();
    }

    return this.loadPaperworkOptions(orderId).then(
      ({ documents, documentOptions }) => {
        this.setState({
          documents,
          documentOptions,
          processModal: false,
          selectedDocumentOption: {},
        });
        this.toggleModal();
      },
    );
  };

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  toggleProcessModal = () => {
    this.setState((prevState) => ({
      processModal: !prevState.processModal,
      shouldIncludeAorDocument: prevState.processModal
        ? false
        : prevState.shouldIncludeAorDocument,
      latestProcessPreview: prevState.processModal
        ? []
        : prevState.latestProcessPreview,
    }));
  };

  openProcessModal = () => {
    const orderIds = this.parseOrderIds();
    const orderId = orderIds[0];

    if (!orderId) {
      this.setState({
        error: "Enter at least one order ID.",
        success: "",
      });
      this.clearMessage();
      return Promise.resolve();
    }

    return this.loadPaperworkOptions(orderId).then(
      ({ documents, documentOptions }) => {
        this.setState({
          documents,
          documentOptions,
          modal: false,
          processModal: true,
          processMode: "manual",
          selectedProcessDocumentOptions: [],
          processOrderIds: [],
          shouldIncludeAorDocument: false,
          latestProcessPreview: [],
          error: "",
          success: "",
        });
      },
    );
  };

  openLatestProcessModal = () => {
    const processOrderIds = this.parseOrderIds();

    if (processOrderIds.length === 0) {
      this.setState({
        error: "Enter at least one order ID.",
        success: "",
      });
      this.clearMessage();
      return Promise.resolve();
    }

    return Promise.all(
      processOrderIds.map((orderId) =>
        this.loadPaperworkOptions(orderId)
          .then(({ documentOptions }) => ({
            orderId,
            documents: this.getLatestDocumentsForOrder(documentOptions),
            previewError: "",
          }))
          .catch((error) => ({
            orderId,
            documents: [],
            previewError: error && error.message ? error.message : `${error}`,
          })),
      ),
    ).then((latestProcessPreview) => {
      this.setState({
        modal: false,
        processOrderIds,
        selectedProcessDocumentOptions: [],
        shouldIncludeAorDocument: false,
        latestProcessPreview,
        processModal: true,
        processMode: "latest",
        error: "",
        success: "",
      });
    });
  };

  renderModal() {
    return (
      <Dialog
        open={this.state.modal}
        onClose={this.toggleModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {`Select Document${this.parseOrderIds()[0] ? ` for Order ${this.parseOrderIds()[0]}` : ""}`}
        </DialogTitle>
        <DialogContent dividers>
          <Autocomplete
            options={this.state.documentOptions}
            value={this.state.selectedDocumentOption}
            onChange={(event, value) => this.handleSelectChange(value)}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Document Type"
                margin="normal"
                fullWidth
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant="contained"
            color="success"
            size="small"
            data-tip={"Select Document"}
            onClick={this.handleSaveClick}
            startIcon={<CheckIcon />}
          >
            Select
          </MUIButton>
          <MUIButton
            variant="contained"
            color="error"
            size="small"
            data-tip={"Cancel"}
            onClick={this.toggleModal}
            startIcon={<CloseIcon />}
          >
            Cancel
          </MUIButton>
          <ReactTooltip />
        </DialogActions>
      </Dialog>
    );
  }

  handleSaveClick = () => {
    if (
      !this.state.selectedDocumentOption ||
      !this.state.selectedDocumentOption.docInfo
    ) {
      this.toggleModal();
      return;
    }

    const documentInfo = this.state.selectedDocumentOption.docInfo;
    console.log(documentInfo);
    try {
      const parsedDocumentInfo = JSON.parse(documentInfo);

      for (let propertyName in parsedDocumentInfo) {
        if (
          parsedDocumentInfo[propertyName] &&
          parsedDocumentInfo[propertyName].millis != null
        ) {
          parsedDocumentInfo[propertyName] =
            parsedDocumentInfo[propertyName].millis;
        }
      }
      document.getElementById("docText").value =
        JSON.stringify(parsedDocumentInfo);
    } catch (error) {
      document.getElementById("docText").value = JSON.stringify(documentInfo);
    }

    this.toggleModal();
  };

  handleProcessPreview = async () => {
    if (this.state.processMode === "manual") {
      const selectedProcessOptions = this.normalizeSelectedOptions(
        this.state.selectedProcessDocumentOptions,
      );
      if (selectedProcessOptions.length === 0) {
        return;
      }

      const documentInfo = selectedProcessOptions[0].docInfo;
      try {
        const parsedDocumentInfo = JSON.parse(documentInfo);

        for (let propertyName in parsedDocumentInfo) {
          if (
            parsedDocumentInfo[propertyName] &&
            parsedDocumentInfo[propertyName].millis != null
          ) {
            parsedDocumentInfo[propertyName] =
              parsedDocumentInfo[propertyName].millis;
          }
        }
        document.getElementById("docText").value =
          JSON.stringify(parsedDocumentInfo);
      } catch (error) {
        document.getElementById("docText").value = JSON.stringify(documentInfo);
      }
      return;
    }

    const firstOrderId = this.state.processOrderIds[0];
    if (!firstOrderId) {
      return;
    }

    const { documentOptions } = await this.loadPaperworkOptions(firstOrderId);
    const previewDocument = this.filterLatestDocumentsForProcessing(
      this.getLatestDocumentsForOrder(documentOptions),
    )[0];
    if (!previewDocument) {
      return;
    }

    const documentInfo = previewDocument.docInfo;
    try {
      const parsedDocumentInfo = JSON.parse(documentInfo);

      for (let propertyName in parsedDocumentInfo) {
        if (
          parsedDocumentInfo[propertyName] &&
          parsedDocumentInfo[propertyName].millis != null
        ) {
          parsedDocumentInfo[propertyName] =
            parsedDocumentInfo[propertyName].millis;
        }
      }
      document.getElementById("docText").value =
        JSON.stringify(parsedDocumentInfo);
    } catch (error) {
      document.getElementById("docText").value = JSON.stringify(documentInfo);
    }
  };

  handleSelectChange = (selectedDocumentOption) => {
    this.setState({
      selectedDocumentOption: selectedDocumentOption || {},
    });
  };

  handleProcessSelectChange = (selectedProcessDocumentOptions) => {
    this.setState({
      selectedProcessDocumentOptions: this.normalizeSelectedOptions(
        selectedProcessDocumentOptions,
      ),
    });
  };

  normalizeSelectedOptions = (selectedOptions) => {
    if (!selectedOptions) {
      return [];
    }

    return Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
  };

  getDocumentTimestamp = (documentOption) => {
    const timestamp = new Date(documentOption.uploadedOn).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  };

  getLatestDocumentsForOrder = (documents) => {
    const documentsByType = new Map();

    documents.forEach((documentRecord) => {
      const existingDocument = documentsByType.get(documentRecord.documentType);
      if (
        !existingDocument ||
        this.getDocumentTimestamp(documentRecord) >
          this.getDocumentTimestamp(existingDocument)
      ) {
        documentsByType.set(documentRecord.documentType, documentRecord);
      }
    });

    const latestDocuments = Array.from(documentsByType.values());
    const emailDocuments = latestDocuments
      .filter(
        (documentRecord) => documentRecord.documentType === "Email Document",
      )
      .sort(
        (leftDocument, rightDocument) =>
          this.getDocumentTimestamp(leftDocument) -
          this.getDocumentTimestamp(rightDocument),
      );
    const otherDocuments = latestDocuments
      .filter(
        (documentRecord) => documentRecord.documentType !== "Email Document",
      )
      .sort(
        (leftDocument, rightDocument) =>
          this.getDocumentTimestamp(leftDocument) -
          this.getDocumentTimestamp(rightDocument),
      );

    return [...otherDocuments, ...emailDocuments];
  };

  isAorDocumentType = (documentType) => {
    return documentType === "AoR Document" || documentType === "AOR Document";
  };

  filterLatestDocumentsForProcessing = (
    documents,
    shouldIncludeAorDocument = this.state.shouldIncludeAorDocument,
  ) => {
    if (shouldIncludeAorDocument) {
      return documents;
    }

    return documents.filter(
      (documentRecord) => !this.isAorDocumentType(documentRecord.documentType),
    );
  };

  handleProcessIncludeAorChange = (changeEvent) => {
    this.setState({
      shouldIncludeAorDocument: changeEvent.target.checked,
    });
  };

  normalizeProcessingPayload = (documentValue) => {
    let payload =
      typeof documentValue === "string"
        ? JSON.parse(documentValue)
        : JSON.parse(JSON.stringify(documentValue));

    for (let propertyName in payload) {
      if (payload[propertyName] && payload[propertyName].millis != null) {
        payload[propertyName] = payload[propertyName].millis;
      }
    }

    return payload;
  };

  isSuccessfulProcessingResponse = (response, expectedKey) => {
    if (
      expectedKey &&
      response &&
      Object.prototype.hasOwnProperty.call(response, expectedKey)
    ) {
      return Boolean(response[expectedKey]);
    }

    if (typeof response === "boolean") {
      return response;
    }

    if (typeof response === "string") {
      return response.toLowerCase() === "true";
    }

    return Boolean(response);
  };

  processDocumentByType = async (documentType, payload) => {
    switch (documentType) {
      case "Equipment Delivery":
        return {
          response:
            await ManualDocumentCreation.createEquipmentDeliveryDocument(
              payload,
            ),
        };
      case "Safety Assessment":
        return {
          response:
            await ManualDocumentCreation.createSafetyAssessment(payload),
        };
      case "Home Assessment":
      case "Home Assessment Web":
        return {
          response: await ManualDocumentCreation.createHomeAssessment(payload),
          successKey: "uploadHomeAssessmentForm",
        };
      case "ABN":
        return {
          response: await ManualDocumentCreation.createABN(payload),
          successKey: "uploadAbnForm",
        };
      case "Pickup":
        return {
          response: await ManualDocumentCreation.createPickup(payload),
          successKey: "uploadPickupForm",
        };
      case "Service Ticket":
        return {
          response: await ManualDocumentCreation.createServiceTicket(payload),
          successKey: "uploadServiceForm",
        };
      case "Complex Paperwork":
        return {
          response:
            await ManualDocumentCreation.createComplexPaperwork(payload),
          successKey: "uploadComplexForm",
        };
      case "Sales Agreement":
        return {
          response: await ManualDocumentCreation.createSalesAgreement(payload),
          successKey: "uploadSalesAgreementForm",
        };
      case "Donation Form":
        return {
          response: await ManualDocumentCreation.createDonationForm(payload),
          successKey: "uploadDonationForm",
        };
      case "Email Document":
        return {
          response: await ManualDocumentCreation.createEmailDocument(payload),
          successKey: "uploadEmailForm",
        };
      case "AoR Document":
      case "AOR Document":
        return {
          response: await ManualDocumentCreation.createAorDocument(payload),
          successKey: "uploadSalesAgreementForm",
        };
      default:
        throw new Error(`Unsupported document type: ${documentType}`);
    }
  };

  processLatestDocumentsForOrder = async (
    orderId,
    shouldIncludeAorDocument = this.state.shouldIncludeAorDocument,
  ) => {
    let stage = "loadDeliveryDocs";
    let apiResponse = null;
    let mergePayload = null;
    let currentDocument = null;
    let processingPayload = null;
    let mergeResponse = null;

    try {
      const { documentOptions } = await this.loadPaperworkOptions(orderId);
      const latestDocuments = this.filterLatestDocumentsForProcessing(
        this.getLatestDocumentsForOrder(documentOptions),
        shouldIncludeAorDocument,
      );

      if (latestDocuments.length === 0) {
        throw new Error("No delivery documents were found.");
      }

      const mostRecentDocument = [...documentOptions].sort(
        (leftDocument, rightDocument) =>
          this.getDocumentTimestamp(rightDocument) -
          this.getDocumentTimestamp(leftDocument),
      )[0];
      mergePayload = this.normalizeProcessingPayload(
        mostRecentDocument.docInfo,
      );

      for (const selectedOption of latestDocuments) {
        currentDocument = selectedOption;
        stage = `process ${selectedOption.documentType}`;

        processingPayload = this.normalizeProcessingPayload(
          selectedOption.docInfo,
        );
        document.getElementById("docText").value =
          JSON.stringify(processingPayload);

        const processResult = await this.processDocumentByType(
          selectedOption.documentType,
          processingPayload,
        );
        apiResponse = processResult.response;

        if (
          !this.isSuccessfulProcessingResponse(
            processResult.response,
            processResult.successKey,
          )
        ) {
          throw new Error(
            `Endpoint returned an unsuccessful response while rebuilding ${selectedOption.documentType}.`,
          );
        }

        apiResponse = null;
        currentDocument = null;
        processingPayload = null;
      }

      stage = "mergePaperwork";
      mergeResponse = await ManualDocumentCreation.mergePaperwork({
        ...mergePayload,
        dontSendSurvey: true,
      });
      apiResponse = mergeResponse;

      if (!this.isSuccessfulProcessingResponse(mergeResponse, "submitMerge")) {
        throw new Error("Merge returned an unsuccessful response.");
      }

      return {
        orderId,
        processedCount: latestDocuments.length,
      };
    } catch (error) {
      const message = `Processing stopped at ${stage} for order ${orderId}: ${error && error.message ? error.message : error}`;
      console.error(message, {
        stage,
        orderId,
        documentType: currentDocument ? currentDocument.documentType : null,
        selectedDocumentId: currentDocument ? currentDocument.value : null,
        apiResponse,
        error,
      });
      throw new Error(message);
    } finally {
      apiResponse = null;
      mergePayload = null;
      currentDocument = null;
      processingPayload = null;
      mergeResponse = null;
    }
  };

  processManualSelectedDocumentsAndMerge = async () => {
    const selectedProcessDocumentOptions = this.normalizeSelectedOptions(
      this.state.selectedProcessDocumentOptions,
    );

    if (selectedProcessDocumentOptions.length === 0) {
      this.setState({
        error: "Select at least one document to process.",
        success: "",
      });
      this.clearMessage();
      return;
    }

    let stage = "processSelectedDocuments";
    let apiResponse = null;
    let mergePayload = null;
    let currentDocument = null;
    let processingPayload = null;
    let mergeResponse = null;

    try {
      for (const selectedProcessDocumentOption of selectedProcessDocumentOptions) {
        currentDocument = selectedProcessDocumentOption;
        stage = `process ${selectedProcessDocumentOption.documentType}`;

        processingPayload = this.normalizeProcessingPayload(
          selectedProcessDocumentOption.docInfo,
        );
        if (!mergePayload) {
          mergePayload = processingPayload;
        }

        document.getElementById("docText").value =
          JSON.stringify(processingPayload);

        const processResult = await this.processDocumentByType(
          selectedProcessDocumentOption.documentType,
          processingPayload,
        );
        apiResponse = processResult.response;

        if (
          !this.isSuccessfulProcessingResponse(
            processResult.response,
            processResult.successKey,
          )
        ) {
          const message = `Processing stopped at ${stage} for order ${this.state.orderIdsInput}: endpoint returned an unsuccessful response.`;
          console.error(message, {
            stage,
            orderId: this.state.orderIdsInput,
            documentType: selectedProcessDocumentOption.documentType,
            selectedDocumentId: selectedProcessDocumentOption.value,
            apiResponse,
          });
          this.setState({
            error: message,
            success: "",
          });
          this.clearMessage();
          return;
        }

        apiResponse = null;
        currentDocument = null;
        processingPayload = null;
      }

      stage = "mergePaperwork";
      mergeResponse = await ManualDocumentCreation.mergePaperwork({
        ...mergePayload,
        dontSendSurvey: true,
      });
      apiResponse = mergeResponse;

      if (!this.isSuccessfulProcessingResponse(mergeResponse, "submitMerge")) {
        const message = `Processing stopped at ${stage} for order ${this.state.orderIdsInput}: merge returned an unsuccessful response.`;
        console.error(message, {
          stage,
          orderId: this.state.orderIdsInput,
          apiResponse,
        });
        this.setState({
          error: message,
          success: "",
        });
        this.clearMessage();
        return;
      }

      this.setState({
        error: "",
        success: `Processed ${selectedProcessDocumentOptions.length} document(s) and merged paperwork.`,
        processModal: false,
        selectedProcessDocumentOptions: [],
      });
      this.clearMessage();
    } catch (error) {
      const message = `Processing stopped at ${stage} for order ${this.state.orderIdsInput}: ${error && error.message ? error.message : error}`;
      console.error(message, {
        stage,
        orderId: this.state.orderIdsInput,
        documentType: currentDocument ? currentDocument.documentType : null,
        selectedDocumentId: currentDocument ? currentDocument.value : null,
        apiResponse,
        error,
      });
      this.setState({
        error: message,
        success: "",
      });
      this.clearMessage();
    } finally {
      apiResponse = null;
      mergePayload = null;
      currentDocument = null;
      processingPayload = null;
      mergeResponse = null;
    }
  };

  processSelectedDocumentsAndMerge = async () => {
    if (this.state.processMode === "manual") {
      return this.processManualSelectedDocumentsAndMerge();
    }

    const orderIds = this.parseOrderIds(this.state.processOrderIds.join(","));

    if (orderIds.length === 0) {
      this.setState({
        error: "Enter at least one order ID.",
        success: "",
      });
      this.clearMessage();
      return;
    }

    try {
      let totalProcessed = 0;

      for (const orderId of orderIds) {
        const result = await this.processLatestDocumentsForOrder(
          orderId,
          this.state.shouldIncludeAorDocument,
        );
        totalProcessed += result.processedCount;
      }

      this.setState({
        error: "",
        success: `Processed ${totalProcessed} document(s) across ${orderIds.length} order(s) and merged paperwork.`,
        processModal: false,
        processOrderIds: [],
        shouldIncludeAorDocument: false,
        latestProcessPreview: [],
      });
      this.clearMessage();
    } catch (error) {
      this.setState({
        error: error && error.message ? error.message : `${error}`,
        success: "",
      });
      this.clearMessage();
    }
  };

  renderContent() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <MUIContainer maxWidth="xl" style={{ marginTop: "2rem" }}>
          <MUICard>
            <MUICardHeader title="Manual Document Builder" />
            <MUICardContent>
              {this.renderMessage()}
              <MUIGrid container spacing={3}>
                <MUIGrid
                  size={{
                    xs: 12,
                    md: 7,
                  }}
                >
                  <textarea
                    id="docText"
                    rows="5"
                    placeholder="Input Area"
                    style={{
                      height: "32rem",
                      width: "100%",
                      textAlign: "left",
                      borderRadius: "4px",
                    }}
                  />
                </MUIGrid>
                <MUIGrid
                  size={{
                    xs: 12,
                    md: 5,
                  }}
                >
                  <MUIGrid container spacing={2}>
                    <MUIGrid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#f7fbff",
                          border: "1px solid #d7e3f3",
                          borderRadius: "10px",
                          height: "100%",
                          marginBottom: "1rem",
                          padding: "0.85rem 1rem 1rem",
                        }}
                      >
                        <Typography
                          style={{
                            color: "#365a86",
                            fontSize: "0.8rem",
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                            marginBottom: "0.35rem",
                            textTransform: "uppercase",
                          }}
                        >
                          Order-Based Tools
                        </Typography>
                        <Typography
                          style={{
                            color: "#5f7391",
                            fontSize: "0.9rem",
                            marginBottom: "0.75rem",
                          }}
                        >
                          Enter one or more order IDs, then review, manually
                          choose docs, or rebuild the latest set.
                        </Typography>
                        <MUITextField
                          label="Order Id(s)"
                          value={this.state.orderIdsInput}
                          multiline
                          rows={4}
                          helperText="Separate multiple order IDs with commas, spaces, or new lines."
                          onChange={(changeEvent) =>
                            this.setState({
                              orderIdsInput: changeEvent.target.value,
                            })
                          }
                          fullWidth
                          margin="normal"
                        />
                        <Stack spacing={1}>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.getPaperWorkById()}
                          >
                            Find Paperwork by Order ID
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.openProcessModal()}
                          >
                            Choose Docs to Process + Merge
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.openLatestProcessModal()}
                          >
                            Rebuild Latest Docs by Order ID(s)
                          </MUIButton>
                        </Stack>
                      </div>
                    </MUIGrid>
                    <MUIGrid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#f7fbff",
                          border: "1px solid #dfe7f2",
                          borderRadius: "10px",
                          height: "100%",
                          marginBottom: "1rem",
                          padding: "0.85rem 1rem 1rem",
                        }}
                      >
                        <Typography
                          style={{
                            color: "#5f7391",
                            fontSize: "0.8rem",
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                            marginBottom: "0.75rem",
                            textTransform: "uppercase",
                          }}
                        >
                          Manual Builder Actions
                        </Typography>
                        <Stack spacing={1}>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createDeliveryPaperwork()}
                          >
                            Create Delivery Paperwork
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createSafetyAssessment()}
                          >
                            Create Safety Paperwork
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createHomeAssessment()}
                          >
                            Create Home Paperwork
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createABN()}
                          >
                            Create ABN Form
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createPickup()}
                          >
                            Create Pickup Form
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createServiceTicket()}
                          >
                            Create Service Ticket
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createComplexPaperwork()}
                          >
                            Create Complex Paperwork
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createSalesAgreement()}
                          >
                            Create Sales Agreement
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createDonationForm()}
                          >
                            Create Donation Form
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createEmailDocument()}
                          >
                            Create Email Document
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.createAorAgreement()}
                          >
                            Create AoR Document
                          </MUIButton>
                          <MUIButton
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => this.mergePaperwork()}
                          >
                            Merge Paperwork
                          </MUIButton>
                        </Stack>
                      </div>
                    </MUIGrid>
                  </MUIGrid>
                </MUIGrid>
              </MUIGrid>
            </MUICardContent>
          </MUICard>
          {this.renderModal()}
          <ManualDocumentBuilderModal
            isOpen={this.state.processModal}
            mode={this.state.processMode}
            activeOrderId={
              this.state.processMode === "manual"
                ? this.parseOrderIds()[0] || ""
                : ""
            }
            documentOptions={this.state.documentOptions}
            selectedDocumentOptions={this.state.selectedProcessDocumentOptions}
            onChange={this.handleProcessSelectChange}
            orderIds={this.state.processOrderIds}
            includeAor={this.state.shouldIncludeAorDocument}
            onToggleIncludeAor={this.handleProcessIncludeAorChange}
            latestPreview={this.state.latestProcessPreview}
            onClose={this.toggleProcessModal}
            onPreview={this.handleProcessPreview}
            onProcess={this.processSelectedDocumentsAndMerge}
          />
        </MUIContainer>
      </ThemeProvider>
    );
  }
}
